/**
 * User operation snapshot schemas.
 *
 * Audit trail of key user operations (login, trade, recharge, etc.).
 */
import { z } from 'zod';

/** Internal: create a snapshot (called by backend services, not by API users). */
export const UserOpSnapshotCreateSchema = z.object({
  user_id: z.number().int().positive(),
  op_type: z.string().min(1).max(32),
  summary: z.string().min(1).max(500),
  detail: z.any().optional(),
  ip: z.string().max(64).optional(),
  ua: z.string().max(512).optional(),
});
export type UserOpSnapshotCreateRequest = z.infer<typeof UserOpSnapshotCreateSchema>;

/** GET /api/admin/user-op-snapshots — list snapshots (admin). */
export const UserOpSnapshotListQuerySchema = z.object({
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(200).default(50),
  user_id: z.coerce.number().int().positive().optional(),
  op_type: z.string().max(32).optional(),
});
export type UserOpSnapshotListQuery = z.infer<typeof UserOpSnapshotListQuerySchema>;
